/** Atomic actions available across ERP modules */
export const PERMISSION_ACTIONS = [
  'view',
  'create',
  'update',
  'delete',
  'export',
  'print',
  'approve',
  'run',
  'remark',
  'register',
  'assign',
  'own',
  'checklist',
  'comment',
  'view_all',
  'manage_territory',
  'reset_password',
  'unlock',
  'manage_sessions',
  'view_auth_log',
  'reset_pin',
  'manage',
  'send',
  'group_manage',
  'select',
  'purchases',
  'link',
  'summary',
  'summary_export',
  'dial',
  'convert',
  'details',
  'give',
  'test',
  'inbox',
  'team_report',
] as const

export type PermissionAction = (typeof PERMISSION_ACTIONS)[number]

/**
 * Permission modules for features that are built today.
 * Add a module here only when its UI + API ship — not for Coming Soon stubs.
 */
export const PERMISSION_MODULES = [
  'dashboard',
  'master_data',
  'customers',
  'suppliers',
  'sales_agents',
  'categories',
  'products',
  'qualities',
  'colors',
  'warehouses',
  'delivery_challans',
  'goods_received',
  'reports',
  'purchase_reports',
  'dispatch_reports',
  'sheets_sync',
  'users',
  'auth_settings',
  'backups',
  'mail',
  'site_form',
  'permissions',
  'sales_leads',
  'tasks',
  'messages',
  'quotations',
  'estimates',
  'bank_accounts',
  'catalog',
  'quotation_terms',
  'calls',
  'old_customers',
] as const

export type PermissionModule = (typeof PERMISSION_MODULES)[number]

/** Canonical permission key: e.g. "customers.create" */
export type PermissionKey = `${PermissionModule}.${PermissionAction}`

export type PermissionMap = Partial<Record<PermissionKey, boolean>>

export interface PermissionGroup {
  module: PermissionModule
  label: string
  description?: string
  actions: PermissionAction[]
}

export const SYSTEM_ROLES = [
  'super_admin',
  'manager',
  'assistant',
  'salesman',
] as const

export type SystemRole = (typeof SYSTEM_ROLES)[number]
